import { AssignmentRestrictionInput, AssignmentRestrictionTypeEnum } from '@/types/schema';

export const DEFAULT_ASSIGNMENT_RESTRICTION: AssignmentRestrictionInput = {
  type: AssignmentRestrictionTypeEnum.All,
};
